import Model from '@/common/models/common.model';
import { store } from '@/common/root';
import {
  VIRTUAL_ROUTER_STATUS_MAP
} from '@/common/constants/virtualRouters.constants';
import {
  DomainProject as DomainProjectSchema,
  ComputeRouter,
  ComputeRouterInterfaces
} from '@schema';
import Network from '@/common/models/network.model';

interface Route {
  id: string,
  index: number,
  destination: string,
  nexthop: string
}

interface InterfaceInfoFixedIp {
  ip_address: string,
  subnet_id: string
}

interface VirtualRouterInterface {
  id: string,
  index: number,
  statusIcon: string,
  statusText: string,
  network_id: string,
  status: string,
  fixed_ips: InterfaceInfoFixedIp[],
  type: string
}
export default class VRouter extends Model {
  declare attributes: ComputeRouter & ComputeRouterInterfaces;

  get statusIcon() {
    return VIRTUAL_ROUTER_STATUS_MAP[this.status].icon;
  }

  get statusText() {
    return VIRTUAL_ROUTER_STATUS_MAP[this.status].text;
  }

  get project(): DomainProjectSchema {
    return (this.projectId && typeof store.getters['projects/getItemById'] === 'function'
      && store.getters['projects/getItemById'](this.projectId)) || {};
  }

  get network(): Network {
    return (this.networkId && typeof store.getters['networks/getItemById'] === 'function'
      && store.getters['networks/getItemById'](this.networkId));
  }

  get projectId(): ID {
    return this.attributes.project_id;
  }

  get domainId(): ID {
    return this.attributes.domain_id;
  }

  get ip() {
    return this.attributes.external_gateway_info?.external_fixed_ips?.[0]?.ip_address;
  }

  get snat(): boolean {
    return this.attributes.external_gateway_info?.enable_snat;
  }

  get routes(): Route[] {
    return (this.attributes.routes || []).map((it, index) => ({ id: `${index}-${it.nexthop}`, index, ...it }));
  }

  get internalInterfaces() {
    return this.attributes.interfaces_info || [];
  }

  get externalInterface() {
    const externalInterface = this.attributes.external_interface;
    const externalGatewayInfo = this.attributes.external_gateway_info;
    if (!externalInterface && !externalGatewayInfo) {
      return null;
    }
    return {
      network_id: externalInterface
        ? externalInterface.network_id
        : externalGatewayInfo.network_id,
      status: externalInterface && externalInterface.status,
      fixed_ips: externalInterface
        ? externalInterface.fixed_ips
        : externalGatewayInfo.external_fixed_ips
    };
  }

  get interfaces(): VirtualRouterInterface[] {
    const { externalInterface, internalInterfaces } = this;
    const items = externalInterface
      ? [{ type: 'external', ...externalInterface }].concat(internalInterfaces as any[])
      : internalInterfaces;

    return items.map((it, index) => ({
      id: it.network_id,
      index,
      statusIcon: VIRTUAL_ROUTER_STATUS_MAP[it.status]?.icon,
      statusText: VIRTUAL_ROUTER_STATUS_MAP[it.status]?.text,
      ...it
    }));
  }

  get networkId(): ID {
    return this.attributes.external_gateway_info?.network_id;
  }

  get networkName() {
    return this.attributes.external_gateway_info?.network_name;
  }

  get internalInterfacesIds(): ID[] {
    return this.internalInterfaces.map(n => n.network_id);
  }

  get createdAt() {
    return this.attributes.created_at;
  }

  get updatedAt() {
    return this.attributes.updated_at;
  }
}
